import type { Section } from "@/types/content";
import HeroSectionBlock from "./HeroSectionBlock";
import RichTextSectionBlock from "./RichTextSectionBlock";
import ImageGallerySectionBlock from "./ImageGallerySectionBlock";
import FeatureListSectionBlock from "./FeatureListSectionBlock";
import TestimonialSectionBlock from "./TestimonialSectionBlock";
import FAQSectionBlock from "./FAQSectionBlock";
import CTASectionBlock from "./CTASectionBlock";
import PricingPackageSectionBlock from "./PricingPackageSectionBlock";
import RelatedPostsSectionBlock from "./RelatedPostsSectionBlock";
import ShopReviewSectionBlock from "./ShopReviewSectionBlock";
import RelatedStoresSectionBlock from "./RelatedStoresSectionBlock";

interface SectionRendererProps {
  sections: Section[];
}

export default function SectionRenderer({ sections }: SectionRendererProps) {
  return (
    <>
      {sections.map((section) => {
        switch (section._type) {
          case "hero":
            return <HeroSectionBlock key={section._key} section={section} />;
          case "richText":
            return (
              <RichTextSectionBlock key={section._key} section={section} />
            );
          case "imageGallery":
            return (
              <ImageGallerySectionBlock
                key={section._key}
                section={section}
              />
            );
          case "featureList":
            return (
              <FeatureListSectionBlock
                key={section._key}
                section={section}
              />
            );
          case "testimonial":
            return (
              <TestimonialSectionBlock
                key={section._key}
                section={section}
              />
            );
          case "faq":
            return <FAQSectionBlock key={section._key} section={section} />;
          case "cta":
            return <CTASectionBlock key={section._key} section={section} />;
          case "pricingPackage":
            return (
              <PricingPackageSectionBlock
                key={section._key}
                section={section}
              />
            );
          case "relatedPosts":
            return (
              <RelatedPostsSectionBlock
                key={section._key}
                section={section}
              />
            );
          case "relatedStores":
            return (
              <RelatedStoresSectionBlock
                key={section._key}
                section={section}
              />
            );
          case "shopReview":
            return (
              <ShopReviewSectionBlock key={section._key} section={section} />
            );
          default:
            return null;
        }
      })}
    </>
  );
}